import { useLocation } from "react-router-dom";
import { useTranslation } from "@helpers/translate";
import { Button } from "@components/library";

import "./StepFour.sass";

const TOTAL_STEPS = 3;

const STEP_BY_ROUTE = {
  "personal-information": 1,
  "id-verification": 2,
  result: 3,
};

export const StepFour = () => {
  const { __ } = useTranslation();
  const location = useLocation();

  const currentStep = (() => {
    const match =
      location.pathname.match(
        /\/profile\/verification\/([^/?#]+)/,
      );

    const route = match?.[1];

    return (
      STEP_BY_ROUTE[route] || 3
    );
  })();

  const openSupportChat = () => {
    document
      .getElementById(
        "sendpulse-chat-wrapper",
      )
      ?.classList.add("active");
  };

  return (
    <div className="pv-result">
      <div className="pv-result__wrapper">
        <p className="pv-result__page">
          {__("verification.step")}{" "}
          {currentStep}/{TOTAL_STEPS}
        </p>

        <h2 className="pv-result__title">
          {__(
            "verification.step4.header",
          )}
        </h2>

        <p className="pv-result__text">
          {__(
            "verification.step4.description",
          )}
        </p>

        <div className="pv-result__info">
          {__(
            "verification.step4.info",
          )}
        </div>
      </div>

      <div className="pv-result__buttons">
        <Button
          color="orange"
          size="middle"
          className="pv-result__next-btn"
          onClick={openSupportChat}
        >
          {__(
            "verification.buttons.contact",
          )}
        </Button>
      </div>
    </div>
  );
};

export default StepFour;
